export type PlainTableProps = {
  columns: string[];
  data: string[][];
  classes: string;
};
export const PlainTable = ({ columns, data, classes }: PlainTableProps) => {
  const ths = columns.map((column, index) => {
    return <th key={index}>{column}</th>;
  });

  return (
    <table className={`plainTable ${classes}`}>
      <thead>
        <tr>{ths}</tr>
      </thead>
      <tbody>
        {data.map((row, index) => {
          return (
            <tr key={index}>
              {row.map((cell, cellIndex) => {
                return <td key={cellIndex}>{cell}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
